import api from "./api";

// 文件上传
// export const uploadFile = (file, savePath) => {
//   const formData = new FormData();
//   formData.append("savePath", `/static/image/dev/${savePath}`);
//   formData.append("multipartFile", file);
//   // 配置请求头部为表单式
//   const config = {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   };
//   return api("put", "/v1/management/file-transfer/upload", formData, config);
// };

// 图片上传
export const uploadImage = (file, savePath) => {
  const formData = new FormData();
  formData.append("savePath", `/static/image/dev/${savePath}`);
  formData.append("multipartFile", file);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("put", "/v1/management/file-transfer/imageUpload", formData, config);
};

// Excel上传
export const uploadExcel = (file, savePath) => {
  const formData = new FormData();
  formData.append("savePath", `/static/image/dev/${savePath}`);
  formData.append("multipartFile", file);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("put", "/v1/management/file-transfer/excelUpload", formData, config);
};
// 视频上传
export const uploadVideo = (file, savePath = "/static/video/", onUploadProgress) => {
  const formData = new FormData();
  formData.append("savePath", savePath);
  formData.append("multipartFile", file);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 30 * 60 * 1000,
    // 原生获取上传进度的事件
    onUploadProgress,
    hideLoading: true,
  };
  return api("put", "/v1/management/file-transfer/upload/video", formData, config);
};

// 图片批量上传
export const uploadImageList = (files, savePath, types = [], watermark = false) => {
  const formData = new FormData();

  files.forEach(item => {
    formData.append("multipartFiles", item);
  });
  types.length &&
    types.forEach(item => {
      formData.append("types", item);
    });
  formData.append("watermark", watermark); // 是否加入水印
  formData.append("savePath", `/static/image/dev/${savePath}`);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return api("put", "/v1/management/file-transfer/uploadImageList", formData, config);
};

// 图片批量上传
export const specialEventAlbumUploadFiles = (files, savePath, types = [], watermark = false) => {
  const formData = new FormData();

  files.forEach(item => {
    formData.append("multipartFiles", item);
  });
  types.length &&
    types.forEach(item => {
      formData.append("types", item);
    });
  formData.append("watermark", watermark); // 是否加入水印
  formData.append("savePath", `/static/image/dev/${savePath}`);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return api("put", "/v1/management/file-transfer/specialEventAlbumUploadFiles", formData, config);
};

// 图片批量上传(ua star)
export const uaStarUploadFiles = (files, savePath, types = [], watermark = false) => {
  const formData = new FormData();

  files.forEach(item => {
    formData.append("multipartFiles", item);
  });
  types.length &&
    types.forEach(item => {
      formData.append("types", item);
    });
  formData.append("watermark", watermark); // 是否加入水印
  formData.append("savePath", `/static/image/dev/${savePath}`);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return api("put", "/v1/management/file-transfer/uaStarUploadFiles", formData, config);
};

// 图片批量上传（不改变文件名）
export const uploadImages = (multipartFiles, savePath) => {
  const formData = new FormData();
  multipartFiles.forEach(item => {
    formData.append("multipartFiles", item);
  });
  formData.append("savePath", `/static/image/dev/${savePath}`);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("put", "/v1/management/file-transfer/uploadFilesButDontChangeFileName", formData, config);
};

// 云点播文件上传
export const putCloudDemandUpload = params => {
  const formData = new FormData();
  formData.append("mediaFile", params.mediaFile);
  params.coverFile && formData.append("coverFile", params.coverFile);

  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 30 * 60 * 1000,
    // 原生获取上传进度的事件
    onUploadProgress: params.onUploadProgress,
    // params.hideLoading 有值取params.hideLoading 没有就默认是trure
    hideLoading: params.hideLoading !== undefined ? params.hideLoading : true,
  };

  // return api("put", `/v1/management/file-transfer/cloudDemandUpload`, formData, config);
  return api("put", `/v1/management/file-transfer/cloudDemandUploadAndRelease`, formData, config);
};
